import { useWatchProperties } from '../../hooks/useWatchProperties';
import { TUDOR_COLORS } from '../../utils/helpers/constants.helper';

export function Icon({
  name,
  size = '24px',
  title,
  className,
  style,
  raw,
  ...props
}) {
  const { shouldEnableLightTheme, isMetas } = useWatchProperties();
  const symbolId = name.startsWith('icon-') ? name : `icon-${name}`;
  const titleId = title ? `${symbolId}-title` : undefined;

  const isSpecificationsIcon = name.includes('specifications');

  let iconColor = TUDOR_COLORS.WHITE;

  if (isSpecificationsIcon) {
    const shouldUseRedIcons = !isMetas;
    iconColor = shouldUseRedIcons ? TUDOR_COLORS.RED : TUDOR_COLORS.WHITE;
  } else if (shouldEnableLightTheme) {
    iconColor = TUDOR_COLORS.BLACK;
  }

  const iconStyle = raw
    ? {}
    : {
        color: iconColor,
        width: size,
        height: size,
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
        ...style,
      };

  return (
    <svg
      key={name}
      className={className}
      style={iconStyle}
      aria-hidden={title ? undefined : true}
      aria-labelledby={titleId}
      role={title ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <use href={`#${symbolId}`} />
    </svg>
  );
}
